<template lang='pug'>
  div
    v-dialog(v-model='dialog', width='800')
      v-card
        v-card-title.headline.primary.white--text(primary-title)
          | {{ $tc('words.patient', 1) | capitalize }}
        v-card-text
          u-form(v-model="result", :json="json", :resultJSON="true")
        v-divider
        v-card-actions
          v-btn(v-if="iuid" color='error', @click='remove') {{ $t('words.removePatient') }}
          v-spacer
          v-btn(color='default', flat, @click='dialog = false') {{ $t('words.cancel') }}
          v-btn(color='primary', @click='save') {{ $t('words.save') }}
          // v-btn(color='primary', @click='save(true)', v-if='!iuid') {{ $t('messages.saveAndStartAttendance') }}
</template>

<script>
import {core, db} from '@/store/firebase'
import apiGestation from '@/api/gestation'
import UForm from '@/components/form/form'
import firestoreUtil from '@/utils/firestore'
import {mapState} from 'vuex'

import formPatient from '@/../functions/shared/formPatient.json'
import {aggregate} from '@/utils/aggregations'
// TODO i18n

export default {
  name: 'uf-patient',

  computed: {
    ...mapState({
      user: state => state.user,
      company: state => state.company,
      companyDoc: (state) => state.ultraFetal.company
    })
  },

  props: {
    iuid: {
      type: String
    },
    value: {
      type: Boolean
    }
  },

  components: {
    UForm
  },

  watch: {
    value (val) {
      this.dialog = val
      if (val) {
        this.init()
      }
    },
    dialog (val) {
      if (!val) this.result = {}
      this.$emit('input', val)
    }
  },

  data () {
    return {
      dialog: false,
      result: {},
      json: formPatient.components[0]
    }
  },

  methods: {
    init () {
      if (this.company) {
        this.$store.dispatch('ultraFetal/getCompany', this.company)
      }
      if (!this.iuid) {
        this.result = {patient: { company: {} }}
        return
      }

      db.collection('patients').doc(this.iuid).get().then(data => {
        if (!data.exists) return

        let patient = firestoreUtil.docToObject(data)
        this.result = {patient: patient}
      })
    },
    save (startGestation) {
      if (!this.checkDependencies()) return
      this.result.patient.timestamp = core.firestore.FieldValue.serverTimestamp()
      this.result.patient.company = aggregate('company', this.companyDoc)
      // nome sempre em letras maiusculas
      if (this.result.patient.name) this.result.patient.name = this.result.patient.name.toUpperCase()
      if (!this.result.patient.iuid) {
        db.collection('patients').add(this.result.patient)
        .then((data) => {
          this.dialog = false
          this.$store.dispatch('ultraFetal/setPatient', this.result.patient)
          if (startGestation === true) {
            const idPatient = data.id
            apiGestation.createGestationAndGestationInteraction(idPatient, this.user, this.company)
              .then(gestationInteraction => {
                this.$router.push(`ultra-fetal/patient/${idPatient}/gestation-interaction/${gestationInteraction.id}`)
              })
          }
        })
        .catch((err) => {
          console.log(err)
          alert(this.$t('messages.anErrorHasOccurred') + '! ' + err.toString())
        })
      } else {
        db.collection('patients').doc(this.result.patient.iuid).set({
          ...this.result.patient
        }, { merge: true })
        .then(() => {
          this.$store.dispatch('ultraFetal/setPatient', this.result.patient)
          alert(this.$t('messages.savedSuccessfully') + '!')
          this.dialog = false
        })
        .catch((err) => {
          console.log(err)
          alert(this.$t('messages.anErrorHasOccurred') + '! ' + err.toString())
        })
        db.collection('scheduling').where('patient.iuid', '==', this.result.patient.iuid).get().then((docs) => {
          let payload = {patient: {}}
          if (this.result.patient.name) payload.patient.name = this.result.patient.name
          if (this.result.patient.birthdate) payload.patient.birthdate = this.result.patient.birthdate
          if (this.result.patient.identity) payload.patient.identity = this.result.patient.identity
          if (this.result.patient.phone) payload.patient.phone = this.result.patient.phone
          if (this.result.patient.sex) payload.patient.sex = this.result.patient.sex
          if (this.result.patient.patId) payload.patient.patId = this.result.patient.patId
          docs.forEach(doc => {
            db.collection('scheduling').doc(doc.id).set({
              ...payload
            }, { merge: true })
          })
        })
      }
    },
    checkDependencies () {
      if (!this.result || !this.result.patient.name) {
        alert('NECESSITA DE NOME')
        return false
      }
      if (!this.result || !this.result.patient.birthdate) {
        alert('NECESSITA DE DATA DE NASCIMENTO')
        return false
      }
      if (!this.result || !this.result.patient.sex) {
        alert('NECESSITA DE SEXO')
        return false
      }
      if (!this.result || !this.result.patient.patId) {
        const patId = new Date().toISOString().replace(/[-:TZ.]/g, '').substring(0, 14)
        this.result.patient.patId = patId
      }
      return true
    },
    remove () {
      this.$swal.fire({
        type: 'warning',
        title: 'deseja excluir este paciente?',
        showCancelButton: true,
        showConfirmButton: true,
        confirmButtonText: 'SIM',
        cancelButtonText: 'NÃO'
      }).then(async (result) => {
        if (result.value) {
          const exam = await db.collection('gestationInteraction').where('patient.id', '==', this.iuid).limit(1).get()
          if (exam.docs && exam.docs[0]) {
            this.$swal.fire({
              type: 'info',
              title: 'Não é possível excluir este paciente, pois há um exame vinculado a ele.',
              showConfirmButton: true,
              confirmButtonText: 'OK'
            })
          } else {
            return db.collection('patients').doc(this.iuid).delete().then(() => {
              alert(this.$t('messages.successfullyRemoved'))
              this.dialog = false
            })
          }
        }
      })
    }
  }
}
</script>

<style lang='stylus' scoped>
</style>



// WEBPACK FOOTER //
// src/components/ultra-fetal/home/Patient.vue